import { lazy, Suspense } from "react";
import styled from "@emotion/styled";
import { Box } from "@wish-ui";
import { SPLASH_INTRO_EXIT_MS, useSplashIntro } from "hooks/useSplashIntro";

// Code-split so the dotLottie runtime only loads when an intro will play.
const SplashIntroAnimation = lazy(() => import("./SplashIntroAnimation"));

// Sits above the global LoaderRenderer (z-index 1400) so app loading
// continues underneath while the intro plays.
const SPLASH_INTRO_Z_INDEX = 1500;

const FullScreenOverlay = styled(Box)`
  opacity: 1;
  transition: opacity ${SPLASH_INTRO_EXIT_MS}ms ease-out;

  &[data-exiting="true"] {
    opacity: 0;
    pointer-events: none;
  }
`;

const CampaignSplashIntro = () => {
  const { splashIntro, isExiting, handleLoadError, markAnimationStarted } =
    useSplashIntro();

  if (!splashIntro) return null;

  return (
    <FullScreenOverlay
      position="fixed"
      top={0}
      right={0}
      bottom={0}
      left={0}
      zIndex={SPLASH_INTRO_Z_INDEX}
      backgroundColor={splashIntro.background}
      data-exiting={isExiting}
      aria-hidden
    >
      <Suspense fallback={null}>
        <SplashIntroAnimation
          splashIntro={splashIntro}
          onLoad={markAnimationStarted}
          onLoadError={handleLoadError}
        />
      </Suspense>
    </FullScreenOverlay>
  );
};

export default CampaignSplashIntro;
